import { Box, Button, Dialog, DialogTitle, Divider, Grid, TextField } from '@mui/material';

interface DialogSecaoProps {
	data: any,
	onChange: (key: string, value: string) => void;
	onChangeSecao: (e: React.ChangeEvent<HTMLInputElement>) => void;
	open: boolean;
	onClose: () => void;
	onSave: () => void;
}
export default function DialogSecao({ data, onChange, onChangeSecao, onClose, open, onSave }: DialogSecaoProps) {

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Nova Seção</DialogTitle>
			<Box padding={2}>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<TextField
							label='Data'
							type='date'
							fullWidth
							value={data.data}
							InputLabelProps={{ shrink: true }}
							onChange={(e) => onChange('data', e.target.value)}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='Imagem da Seção'
							type='file'
							InputLabelProps={{ shrink: true }}
							onChange={onChangeSecao}
							inputProps={{ accept: 'image/jpeg, image/png' }}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							fullWidth
							label='Descrição'
							value={data.descricao}
							onChange={(e) => onChange('descricao', e.target.value)}
						/>
					</Grid>
					<Grid item xs={12}>
						<Divider />
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='X0 - Valor em metros lado inferior esquerdo'
							value={data.x0}
							onChange={(e) => onChange('x0', e.target.value)}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='Y0 - Valor em metros lado inferior esquerdo'
							value={data.y0}
							onChange={(e) => onChange('y0', e.target.value)}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='X1 - Valor em metros lado superior direito'
							value={data.x1}
							onChange={(e) => onChange('x1', e.target.value)}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='Y1 - Valor em metros lado superior direito'
							value={data.y1}
							onChange={(e) => onChange('y1', e.target.value)}
						/>
					</Grid>
				</Grid>
				<Box display='flex' justifyContent={'center'} padding={1} width={'100%'}>
					<Button onClick={onSave} variant='outlined'>Salvar Seção</Button>
				</Box>
			</Box>
		</Dialog>
	);
}